import React from 'react'
import PropTypes from 'prop-types'
import Row from 'react-bootstrap/Row'
import { createUseStyles } from 'react-jss'
import Col from 'react-bootstrap/Col'
import moment from 'moment'
import 'moment/locale/ru'  // without this line it didn't work

const useStyles = createUseStyles({
  textStyle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000000'
  },
  labelStyle: {
    fontSize: 14,
    color: '#000000',
    opacity: 0.5,
  },
  whiteBlock: {
    backgroundColor: '#fff',
  }
})

const defaultProps = {
  label: '',
  value: '',
  date: false
}

const propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  date:  PropTypes.bool,
}

const InfoBlock = ({ label, value, date }) => {
  const classes = useStyles()
  moment.locale('ru')
  return (
    <Row>
      <Col md={12} lg={12} xl={12} sm={12} xs={12}>
        <div className={classes.whiteBlock}>
          <p className={classes.labelStyle}>{label}</p>
          {!date &&
          <p className={classes.textStyle}>{value}</p>
          }
          { date &&
            <p className={classes.textStyle}>
            { value ? moment(value).format('LL') : 'Не указана'}
            </p>
          }
        </div>
      </Col>
    </Row>
  )
}

InfoBlock.defaultProps = defaultProps
InfoBlock.propTypes = propTypes

export default InfoBlock



// WEBPACK FOOTER //
// ./src/App/component/ConfirmOrder/InfoBlock.jsx